import { useState, useEffect } from 'react'
import { breakpoints } from '../utils'

const useMedia = (values: string[], defaultValue: string, queries: string[] = null): string => {
  const [value, setMatch] = useState(defaultValue)

  const match = () => {
    const definedQueries =
      queries ||
      Object.keys(breakpoints)
        .map((key) => breakpoints[key])
        .reverse()

    const matchingQuery = definedQueries.findIndex((item) => window.matchMedia(item).matches)
    return values[matchingQuery] || defaultValue
  }

  useEffect(() => {
    const handler = () => setMatch(match)
    window.addEventListener('resize', handler)
    handler()
    setMatch(match)
    return () => window.removeEventListener('resize', handler)
  }, [])

  return value
}

export default useMedia
